/* hairUP | naglowek: szuflada nawigacji */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-hu-drawer]');
    if (!drawer || drawer.dataset.ready === 'true') return;
    drawer.dataset.ready = 'true';

    var opener = document.querySelector('[data-hu-drawer-open]');
    var panel = drawer.querySelector('.hu-drawer__panel');
    var lastFocus = null;

    function focusables() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('a[href], button:not([disabled])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.dataset.open = 'true';
      document.body.dataset.huLock = 'true';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var f = focusables();
      if (f.length) f[0].focus();
    }

    function close() {
      drawer.dataset.open = 'false';
      document.body.dataset.huLock = 'false';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);
    Array.prototype.slice.call(drawer.querySelectorAll('[data-hu-drawer-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (drawer.dataset.open !== 'true') return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
